import {ROLES} from "../authentication/utils";
import {isNullOrUndefined} from "util";

/**
 * @typedef {object} Client
 * @property {*} client_id
 * @property {*} role_id
 * @property {*} can_license
 */

/**
 * @typedef {object} RequestData
 * @property {string} name
 * @property {string} old_password
 * @property {string} password
 * @property {string} email
 * @property {*} imageFile
 * @property {*} roleId
 * @property {boolean} canCreateClients
 * @property {Client[]} client_roles
 * @property {string} description
 */

/**
 * @param {RequestData} data
 */
export const makeFormData = data => {

  const form = new FormData();

  if (data.name) form.append("name", data.name);
  if (!isNullOrUndefined(data.email)) form.append("email", data.email);
  if (!isNullOrUndefined(data.newEmail)) form.append("new_email", data.newEmail);
  if (data.roleId) form.append("role_id", data.roleId);
  if (data.oldPassword) form.append("old_password", data.oldPassword);
  if (data.password) form.append("password", data.password);
  if (data.selectedCreator) {
    form.append('content_creator_id', data.selectedCreator.value);
  } else if (data.contentCreatorId) {
    form.append('content_creator_id', data.contentCreatorId);
  }
  if (data.language) form.append("language", data.language)
  if (data.imageFile) form.append("image", data.imageFile, data.imageFile.name);
  if (!isNullOrUndefined(data.description)) form.append("description", data.description);

  return form;
};
